import type { ReactNode } from 'react';
import { match, type AnyRead, type Arms } from './read';

/**
 * {@link match} as a component: one render prop per arm the read can be in. Each platform passes
 * its own skeleton, error and offline elements; a missing arm is a type error.
 */
export function ReadView<Rd extends AnyRead>(props: { read: Rd } & Arms<Rd, ReactNode>): ReactNode {
  const { read, ...arms } = props;
  return match(read, arms as unknown as Arms<Rd, ReactNode>);
}
